/**
 * Non WooCommerce
 *
 */
import Accordions from './accordions'
import Scroll from './animations/scroll'
import Heights from './matchHeight'
import Sliders from './sliders'
import Filter from './filters'
import Menu from './menu'
import Tabs from "./tabs"
import Video from "./video"
import {Maps} from "./map";

window.addEventListener('DOMContentLoaded', () => {

	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + (Math.random() * 0xffffff << 0).toString(16)
	// })

	Heights()
	Sliders()
	Filter()
	Menu()
	Video()
	Maps()


	new Scroll(
		document.querySelectorAll('[data-fade-in]'),
		{
			opacity: 0,
			top: 20,
			position: 'relative'
		},
		{
			opacity: 1,
			top: 0,
			duration: 1,
		}
	)


	// Default Accordions
	const accordionSections = document.querySelectorAll('[data-accordions]')

	if (accordionSections.length) {
		accordionSections.forEach(accordions => {
			new Accordions(accordions, '[data-accordion]', true)
		})
	}

	// Default Tabs
	const tabs = document.querySelectorAll('[data-tabs]')

	if (tabs.length) {
		tabs.forEach(tab => {
			new Tabs(tab)
		})
	}


	let see_more_triggers = document.querySelectorAll('.js-see-more');

	if(see_more_triggers) {
		see_more_triggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => {
				let text = trigger.innerText;
				trigger.innerText = text === 'See more' ? 'See less' : 'See more';

				let parent = trigger.parentNode;
				let previous = parent.previousElementSibling;

				previous.classList.toggle('active');
			})
		})
	}
})
